export class CommentNotFoundError extends Error { }
